import { defineMessage, useIntl } from 'react-intl'
import styled from 'styled-components'
import { rem } from 'polished'
import Image from 'components/Common/Image/Image'

export const IPP_LOGO_ID = 'ipp-financial-protection-logo'

/** Artwork is 260×210. “Part of DUAL” is about a fifth of the height, so these boxes keep that line near 14px in the trust bar and 16px in the footer. */
export const IPP_LOGO_ASPECT_RATIO = 260 / 210
export const IPP_TRUST_BAR_HEIGHT = 72
export const IPP_FOOTER_HEIGHT = 80

export const ippLogoAltMessage = defineMessage({
  id: 'IbZ5YEWMlxDg7uEHJwJa',
  defaultMessage: 'International Passenger Protection',
  description: 'Alt text for the IPP financial failure protection logo on European storefronts',
})

const Slot = styled.div`
  aspect-ratio: ${IPP_LOGO_ASPECT_RATIO};
`

const TrustBarSlot = styled(Slot)`
  height: ${rem(IPP_TRUST_BAR_HEIGHT)};
`

const FooterSlot = styled(Slot)`
  height: ${rem(IPP_FOOTER_HEIGHT)};
`

function IppLogoImage({ height }: { height: number }) {
  const intl = useIntl()

  return (
    <Image
      id={IPP_LOGO_ID}
      alt={intl.formatMessage(ippLogoAltMessage)}
      height={height}
      fit="center"
      objectFit="contain"
      quality="best"
      format="png"
      disableBlur
    />
  )
}

export function IppTrustBarLogo() {
  return (
    <TrustBarSlot>
      <IppLogoImage height={IPP_TRUST_BAR_HEIGHT} />
    </TrustBarSlot>
  )
}

export function IppFooterLogo() {
  return (
    <FooterSlot>
      <IppLogoImage height={IPP_FOOTER_HEIGHT} />
    </FooterSlot>
  )
}
